var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickMenuSteelWing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 568,
    height: 167,
    viewBox: "0 0 568 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.361328 0.0507812C6.62037 33.9909 31.328 41.022 61.1775 48.1846C89.45 54.9693 84.423 59.0763 107.767 86.8395C158.299 146.966 230.467 168.536 284.072 165.907C211.904 163.082 139.966 116.443 106.354 50.8131C94.9041 28.4382 93.3598 24.4463 68.1758 21.0621C30.0466 15.9366 9.11741 8.28117 0.361328 0.0507812Z",
    fill: "url(#paint0_linear_318_2502)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5585 33.4303C38.1117 27.5655 12.1884 26.087 0.541016 0.410156C6.80006 34.3503 31.5077 41.3814 61.3572 48.544C89.6297 55.3287 84.6027 59.4357 107.947 87.1989C158.479 147.325 230.647 168.895 284.251 166.267C238.171 164.722 204.395 154.586 165.346 128.466C140.901 112.12 120.087 91.4045 104.136 65.4483C100.472 59.5014 96.9894 53.4231 92.981 47.7226C85.4898 37.0609 75.4524 36.1738 63.5421 33.4303H63.5585Z",
    fill: "url(#paint1_linear_318_2502)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1054 55.4155C37.7023 53.3292 19.4673 48.7787 11.1055 37.7227C14.9989 57.9454 26.942 72.747 48.824 75.9669C66.4676 78.5625 86.4275 76.7554 97.4671 87.3679C84.0455 64.6152 74.9115 59.6047 50.1054 55.4155Z",
    fill: "url(#paint2_linear_318_2502)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.1699 89.1072C66.6312 87.2016 40.5108 89.8958 29.0605 77.7227C35.6481 100.87 52.5196 107.802 74.5823 108.295C90.041 108.64 114.404 112.862 127.513 122.85C108.802 105.009 104.925 92.2121 81.1699 89.1072Z",
    fill: "#B26316"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0605 77.7227C37.1759 90.865 47.3284 95.4977 62.13 97.1569C98.945 101.264 100.226 98.1754 127.513 122.85C108.802 105.009 104.925 92.2121 81.1699 89.1072C66.6312 87.2016 40.5108 89.8958 29.0605 77.7227Z",
    fill: "url(#paint3_linear_318_2502)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.13 97.1569C47.3284 95.4977 37.1759 90.865 29.0605 77.7227C35.6481 100.87 52.5196 107.802 74.5823 108.295C79.0015 108.394 84.1598 108.804 89.581 109.593C103.068 111.531 118.166 115.72 127.53 122.85C106.272 103.63 100.801 101.264 82.0078 99.2104C76.6851 98.6354 70.2782 98.0769 62.1464 97.1569H62.13Z",
    fill: "url(#paint4_linear_318_2502)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0898 37.7383C18.3674 54.2319 30.2777 61.6081 47.7898 65.5836C69.179 70.4463 80.6293 67.3414 97.4679 87.3835C84.0463 64.6308 74.9123 59.6203 50.1062 55.4312C37.7031 53.3448 19.4681 48.7943 11.1063 37.7383H11.0898Z",
    fill: "url(#paint5_linear_318_2502)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.410156C8.88751 19.9922 26.0711 25.4956 45.029 29.619C34.5479 25.5942 26.9747 19.5815 23.4919 12.2875C12.0581 8.64055 4.45197 4.59928 0 0.410156Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1298 50.3385C22.573 47.5458 15.4761 43.5373 11.0898 37.7383C18.3674 54.2319 30.2777 61.6081 47.7898 65.5836C48.0855 65.6493 48.3648 65.715 48.6441 65.7808C39.6087 62.413 34.0889 57.5668 30.1134 50.3549L30.1298 50.3385Z",
    fill: "url(#paint6_radial_318_2502)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0327 86.2323C39.8865 84.836 33.4139 82.3553 29.0605 77.7227C37.1759 90.865 47.3284 95.4977 62.13 97.1569C67.5348 97.7647 72.1674 98.2083 76.2416 98.619C63.1814 96.3355 55.066 94.1834 47.0327 86.2323Z",
    fill: "url(#paint7_radial_318_2502)"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0259 23.3286C84.2588 25.9899 90.1892 28.0763 95.709 36.6024C105.582 51.8146 119.201 82.0749 148.278 106.783C131.292 90.6667 116.934 71.8896 106.354 51.2397C94.9041 28.8648 93.3598 24.8728 68.1758 21.4887C30.0466 16.3467 9.11741 8.70776 0.361328 0.460938C16.0993 17.7924 45.9324 20.0759 67.0259 23.3286Z",
    fill: "url(#paint8_linear_318_2502)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.805 128.482C133.099 109.557 117.755 89.7125 97.6146 57.2016C89.7292 44.4699 82.3531 39.3116 74.3526 36.5517C59.7975 31.5247 43.4681 31.5412 27.0566 24.625C44.0431 30.4241 61.2103 29.9312 74.7962 34.5475C85.4415 38.1616 91.027 42.9421 99.2902 55.8709C122.437 92.1109 132.048 106.19 164.821 128.482H164.805Z",
    fill: "url(#paint9_linear_318_2502)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5176 51.993C38.1612 66.811 53.1927 65.7924 68.5364 68.9138C81.0545 71.4601 92.9812 76.9142 103.971 96.3977C95.2811 83.6496 87.3792 74.5485 68.1586 70.3594C52.1085 66.8767 35.467 68.0431 20.5176 51.9766V51.993Z",
    fill: "url(#paint10_linear_318_2502)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4238 88.6289C57.9402 102.675 85.9991 93.4916 107.438 106.043C132.786 120.877 147.062 144.467 179.458 160.238C142.79 144.484 134.067 124.425 107.75 108.425C100.587 104.071 94.0488 102.478 88.2333 101.311C72.9553 98.2392 53.3897 101.18 38.4403 88.6289H38.4238Z",
    fill: "url(#paint11_linear_318_2502)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.437 0.414865C561.178 34.355 536.47 41.3861 506.621 48.5487C478.348 55.3334 483.375 59.4404 460.031 87.2036C409.499 147.33 337.331 168.9 283.727 166.271C355.894 163.446 427.832 116.807 461.444 51.1772C472.894 28.8023 474.438 24.8103 499.622 21.4262C537.768 16.2842 558.697 8.64526 567.453 0.398438L567.437 0.414865Z",
    fill: "url(#paint12_linear_318_2502)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.438 0.77424C555.79 26.4511 529.867 27.9296 504.42 33.7944C492.526 36.5378 482.489 37.4249 474.981 48.0867C470.973 53.8036 467.49 59.8655 463.827 65.8124C447.875 91.7685 427.061 112.484 402.616 128.83C363.567 154.934 329.791 165.086 283.711 166.631C355.879 163.805 427.817 117.166 461.428 51.5365C472.879 29.1617 474.423 25.1697 499.607 21.7856C537.752 16.6436 558.682 9.00463 567.438 0.757812V0.77424Z",
    fill: "url(#paint13_linear_318_2502)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M504.058 33.8131C529.488 27.9319 555.428 26.4698 567.076 0.792969C560.817 34.7331 536.109 41.7642 506.259 48.9268C477.987 55.7115 483.014 59.8185 459.67 87.5817C409.137 147.708 336.97 169.278 283.365 166.649C329.446 165.105 363.221 154.969 402.271 128.849C426.715 112.503 447.53 91.7873 463.481 65.8311C467.144 59.8842 470.627 53.8059 474.636 48.1054C482.127 37.4437 492.164 36.5566 504.074 33.8131H504.058Z",
    fill: "url(#paint14_linear_318_2502)"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M517.331 55.4155C529.734 53.3292 547.969 48.7787 556.331 37.7227C552.438 57.9454 540.495 72.747 518.613 75.9669C500.969 78.5625 481.009 76.7554 469.953 87.3679C483.375 64.6152 492.509 59.6047 517.315 55.4155H517.331Z",
    fill: "url(#paint15_linear_318_2502)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.267 89.1072C500.806 87.2016 526.926 89.8958 538.376 77.7227C531.789 100.87 514.917 107.802 492.855 108.295C477.396 108.64 453.033 112.862 439.924 122.85C458.635 105.009 462.512 92.2121 486.267 89.1072Z",
    fill: "#B26316"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M538.376 77.7227C530.261 90.865 520.109 95.4977 505.307 97.1569C468.492 101.264 467.211 98.1754 439.924 122.85C458.635 105.009 462.512 92.2121 486.267 89.1072C500.806 87.2016 526.926 89.8958 538.376 77.7227Z",
    fill: "url(#paint16_linear_318_2502)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M505.306 97.1569C520.107 95.4977 530.26 90.865 538.375 77.7227C531.788 100.87 514.916 107.802 492.853 108.295C488.434 108.394 483.276 108.804 477.855 109.593C464.367 111.531 449.27 115.72 439.906 122.85C461.164 103.63 466.634 101.264 485.428 99.2104C490.751 98.6354 497.158 98.0769 505.289 97.1569H505.306Z",
    fill: "url(#paint17_linear_318_2502)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.349 37.7383C549.071 54.2319 537.161 61.6081 519.649 65.5836C498.26 70.4463 486.809 67.3414 469.971 87.3835C483.392 64.6308 492.526 59.6203 517.332 55.4312C529.736 53.3448 547.971 48.7943 556.332 37.7383H556.349Z",
    fill: "url(#paint18_linear_318_2502)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.437 0.410156C558.55 19.9922 541.366 25.4956 522.408 29.619C532.889 25.5942 540.462 19.5815 543.945 12.2875C555.363 8.65698 562.969 4.61571 567.421 0.426584L567.437 0.410156Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M537.309 50.3385C544.866 47.5458 551.963 43.5373 556.349 37.7383C549.072 54.2319 537.161 61.6081 519.649 65.5836C519.354 65.6493 519.074 65.715 518.795 65.7808C527.83 62.413 533.35 57.5668 537.326 50.3549L537.309 50.3385Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M520.404 86.2323C527.55 84.836 534.023 82.3553 538.376 77.7227C530.261 90.865 520.108 95.4977 505.307 97.1569C499.902 97.7647 495.269 98.2083 491.195 98.619C504.256 96.3355 512.371 94.1834 520.404 86.2323Z",
    fill: "url(#paint19_radial_318_2502)"
  }), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500.413 23.3286C483.18 25.9899 477.249 28.0763 471.73 36.6024C461.856 51.8146 448.238 82.0749 419.16 106.783C436.147 90.6667 450.505 71.8896 461.084 51.2397C472.535 28.8648 474.079 24.8728 499.263 21.4887C537.408 16.3467 558.338 8.70776 567.094 0.460938C551.356 17.7924 521.523 20.0759 500.429 23.3286H500.413Z",
    fill: "url(#paint20_linear_318_2502)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M402.616 128.482C434.322 109.557 449.666 89.7125 469.806 57.2016C477.692 44.4699 485.068 39.3116 493.068 36.5517C507.623 31.5247 523.953 31.5412 540.364 24.625C523.378 30.4241 506.211 29.9312 492.625 34.5475C481.979 38.1616 476.394 42.9421 468.131 55.8709C444.984 92.1109 435.373 106.19 402.6 128.482H402.616Z",
    fill: "url(#paint21_linear_318_2502)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M546.919 51.993C529.275 66.811 514.244 65.7924 498.9 68.9138C486.382 71.4601 474.455 76.9142 463.465 96.3977C472.155 83.6496 480.057 74.5485 499.278 70.3594C515.328 66.8767 531.969 68.0431 546.919 51.9766V51.993Z",
    fill: "url(#paint22_linear_318_2502)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M529.012 88.6289C509.496 102.675 481.437 93.4916 459.999 106.043C434.65 120.877 420.374 144.467 387.979 160.238C424.646 144.484 433.369 124.425 459.686 108.425C466.849 104.071 473.387 102.478 479.203 101.311C494.481 98.2392 514.046 101.18 528.996 88.6289H529.012Z",
    fill: "url(#paint23_linear_318_2502)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_2502",
    x1: 0.361328,
    y1: 83.094,
    x2: 284.088,
    y2: 83.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_2502",
    x1: 0.541016,
    y1: 83.4533,
    x2: 284.268,
    y2: 83.4533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B5AA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_318_2502",
    x1: 11.089,
    y1: 62.5617,
    x2: 97.4671,
    y2: 62.5617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B5AA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_318_2502",
    x1: 29.0605,
    y1: 100.295,
    x2: 127.513,
    y2: 100.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_318_2502",
    x1: 29.0605,
    y1: 100.295,
    x2: 127.513,
    y2: 100.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B5AA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_318_2502",
    x1: 11.0898,
    y1: 62.5609,
    x2: 97.4679,
    y2: 62.5609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_318_2502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.867 51.7513) scale(16.5758 16.5758)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#0C0B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4B4432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#827656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AE9F74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D1BE8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EAD59B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F9E3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8A9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_318_2502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.8385 67.2909) scale(47.181 47.181)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#0C0B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4B4432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#827656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AE9F74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D1BE8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EAD59B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F9E3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_318_2502",
    x1: 0.361328,
    y1: 53.6217,
    x2: 148.295,
    y2: 53.6217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_318_2502",
    x1: 27.0566,
    y1: 76.5537,
    x2: 164.805,
    y2: 76.5537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_318_2502",
    x1: 20.5176,
    y1: 74.2036,
    x2: 103.971,
    y2: 74.2036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_318_2502",
    x1: 38.4238,
    y1: 124.425,
    x2: 179.458,
    y2: 124.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_318_2502",
    x1: 283.71,
    y1: 83.4581,
    x2: 567.437,
    y2: 83.4581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_318_2502",
    x1: 567.438,
    y1: 83.7189,
    x2: 283.711,
    y2: 83.7189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_318_2502",
    x1: 567.076,
    y1: 83.8197,
    x2: 283.349,
    y2: 83.8197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7CBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B5AA3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_318_2502",
    x1: 469.97,
    y1: 62.5617,
    x2: 556.348,
    y2: 62.5617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B5AA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_318_2502",
    x1: 538.376,
    y1: 100.295,
    x2: 439.924,
    y2: 100.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_318_2502",
    x1: 538.375,
    y1: 100.295,
    x2: 439.923,
    y2: 100.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B5AA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_318_2502",
    x1: 556.349,
    y1: 62.5609,
    x2: 469.971,
    y2: 62.5609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_318_2502",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(503.598 67.2909) rotate(180) scale(47.181 47.181)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#010101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#0C0B08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4B4432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#827656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#AE9F74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D1BE8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EAD59B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#F9E3A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_318_2502",
    x1: 451.605,
    y1: 125.51,
    x2: 534.616,
    y2: -18.2669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_318_2502",
    x1: 431.792,
    y1: 145.321,
    x2: 511.205,
    y2: 7.78639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86759D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBE1EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_318_2502",
    x1: 546.919,
    y1: 74.2036,
    x2: 463.465,
    y2: 74.2036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_318_2502",
    x1: 529.012,
    y1: 124.425,
    x2: 387.979,
    y2: 124.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE1EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#99ABD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#7672A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70588D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickMenuSteelWing);
export default __webpack_public_path__ + "static/media/quick-menu-steel-wing.f7c9a273041289a74f238a9fecd6a98b.svg";
export { ForwardRef as ReactComponent };